import { render, staticRenderFns } from "./RejectionDialog.vue?vue&type=template&id=27dddf81&scoped=true"
import script from "./RejectionDialog.vue?vue&type=script&lang=ts"
export * from "./RejectionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dddf81",
  null
  
)

export default component.exports